module.exports = __webpack_public_path__ + "static/quickstart-6-a37c0530f88357637b1ad696051df6d8.png";